import { STEP } from '../constants';

export default {
  widgets: {
    applicationCompletionFlow: {
      title: 'Оформление',
      steps: {
        [STEP.FILL_MARKING]: 'Маркировка товаров',
        [STEP.FILL_IMEIS]: 'IMEI товаров',
        [STEP.SELL_TO_ALIF]: 'Продать Алифу',
        [STEP.COMPLETION]: 'Оформление',
        [STEP.SEND_FOR_DELIVERY]: 'Передать на доставку',
      },
      alifDelivery: 'Доставка через Alif Delivery',
      createAlifDeliveryLink: 'Создать доставку',
      edit: 'Изменить',
      cancel: 'Отменить',
    },
  },
};
